import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { hasAllPermissions, hasPermission, useCheckPermissions, useTableFilter } from '@/shared';
import { useFetchPresentacion, useUpdatePresentacion } from '@/shared/actions/erp';
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
  SwitchComponente,
} from '@/shared/components/ui';
import { Presentacion } from '@/shared/interfaces';
import { useUiConfirmModalStore } from '@/store/ui';
import { PermissionsEnum } from '@/auth/interfaces';

const returnUrlPresentacion = '/inventario/presentacion';

export interface PresentacionPageInterface {}

const PresentacionPage: React.FC<PresentacionPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_presentacion)

  const navigate = useNavigate();

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
  } = useTableFilter();
  const { pageIndex } = pagination;

  ///* fetch data
  const {
    data: PresentacionPagingRes,
    isLoading,
    isRefetching,
  } = useFetchPresentacion({
    page: pageIndex + 1,
    nombre: searchTerm,
    
  });

  ///* mutations
  const updatePresentacionMutation = useUpdatePresentacion({navigate, returnUrl: returnUrlPresentacion});
  ///* global state
  const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    s => s.setConfirmDialogIsOpen
  );
  ///* handlers
  const onEdit = (original:Presentacion) => {
    navigate(`${returnUrlPresentacion}/editar/${original.id_presentacion}`);
  };

  ///* columns
  const columns = useMemo<MRT_ColumnDef<Presentacion>[]>(
    () => [
      {
        accessorKey: 'numero_referencia',
        header: 'Numero referencia',
        size: 300,
      },
      {
        accessorKey: 'numero_referencia',
        header: 'Numero referencia',
        size: 300,
      },
      {
        accessorKey: 'descripcion',
        header: 'Descripción',
        size: 300,
      },
      {
        accessorKey: 'nombre',
        header: 'Nombre',
        size: 300,
      },
      {
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <SwitchComponente
            estadoSwitch={row.original.estado}
            titulo={row.original.estado ? 'Activo' : 'Inactivo'}
            setEstadoSwitch={centro_costo => {
              if (!hasPermission(PermissionsEnum.api_change_presentacion)) return;
              setConfirmDialog({
                isOpen: true,
                title: 'Cambiar Estado',
                subtitle:
                  '¿Está seguro que desea cambiar el estado de este registro ?',
                onConfirm: () => {
                  setConfirmDialogIsOpen(false);
                  updatePresentacionMutation.mutate({
                    id: row.original.id_presentacion!,
                    data: {
                      ...row.original,
                      estado: centro_costo as boolean,
                    },
                  });
                },
              });
            }}
          />
        ),
      },
    ],
    []
  );

  return (
    <SingleTableBoxScene title="Presentaciones" urlRedirect={`${returnUrlPresentacion}/crear`} enableRedirect={hasPermission(PermissionsEnum.api_add_presentacion)}>
      <CustomSearch onChange={onChangeFilter} value={globalFilter} text="Presentaciones" />

      <GeneralTable<Presentacion>
        columns={columns}
        data={PresentacionPagingRes?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={PresentacionPagingRes?.data?.count}
        // // actions
        enableColumnActions={hasAllPermissions([
          PermissionsEnum.api_change_presentacion,
        ])}
        // crud
        onEdit={onEdit}
        canEdit={hasAllPermissions([
          PermissionsEnum.api_change_presentacion,
        ])}
        canDelete={false}
      />
    </SingleTableBoxScene>
  );
};

export default PresentacionPage;
